import { Card, Col, Container, Row } from "react-bootstrap";

interface EmployerDetailsProps {
  employerDetails: {
    employerName: string;
    employerAddress: string;
    employerCity: string;
    employerState: string;
    employerZipcode: string;
    employerCountry: string;
    employerContact: string;
    empcontactemailaddress: string;
    empcontactphonenumber: string;
    empcontactfaxnumber: string;
  };
  isViewScheduleCalender?: boolean;
}

const EmployerDetailsCard: React.FC<EmployerDetailsProps> = ({
  employerDetails,
  isViewScheduleCalender = false,
}) => {
  return (
    <>
      <Row className="bg-theme p-3  mb-0 rounded mx-0">
        {/* Employer Name */}
        <Col sm={3} className="d-flex align-items-center border-end">
          <strong>{employerDetails.employerName}</strong>
        </Col>

        {/* Employer Address */}
        <Col sm={3} className="border-end">
          <Card
            border="primary"
            style={{
              ...( !isViewScheduleCalender && { minWidth: "200px" } ),
              maxWidth: "400px",
              minHeight: "91px",
              maxHeight: "110px",
            }}
          >
            <Card.Body>
              <Card.Text>
                {!(
                  employerDetails.employerAddress ||
                  employerDetails.employerCity ||
                  employerDetails.employerState ||
                  employerDetails.employerCountry ||
                  employerDetails.employerZipcode
                ) ? (
                  <span className="text-danger">No Record Found</span>
                ) : (
                  <>
                    {employerDetails.employerAddress && (
                      <>
                        {employerDetails.employerAddress} <br />
                      </>
                    )}
                    {employerDetails.employerCity && (
                      <>
                        {employerDetails.employerCity}
                        {employerDetails.employerState ||
                        employerDetails.employerCountry
                          ? ", "
                          : ""}
                      </>
                    )}
                    {employerDetails.employerState && (
                      <>
                        {employerDetails.employerState}
                        {employerDetails.employerCountry ? ", " : ""}
                      </>
                    )}
                    {employerDetails.employerCountry && (
                      <>
                        {employerDetails.employerCountry} <br />
                      </>
                    )}
                    {employerDetails.employerZipcode && (
                      <>{employerDetails.employerZipcode}</>
                    )}
                  </>
                )}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Employer Contact */}
        <Col sm={3}>
          <Card
            border="dark"
            style={{ minWidth: "200px", minHeight: "91px", maxHeight: "110px" }}
          >
            <Card.Body>
              <Card.Text>
                {employerDetails.employerContact && (
                  <>
                    {employerDetails.employerContact} <br />
                  </>
                )}

                {employerDetails.empcontactemailaddress ||
                employerDetails.empcontactphonenumber ||
                employerDetails.empcontactfaxnumber ? (
                  <>
                    {employerDetails.empcontactemailaddress && (
                      <>
                        {employerDetails.empcontactemailaddress.replaceAll(
                          ",",
                          ", "
                        )}{" "}
                        <br />
                      </>
                    )}
                    {employerDetails.empcontactphonenumber && (
                      <>
                        {employerDetails.empcontactphonenumber.replaceAll(
                          ",",
                          ", "
                        )}{" "}
                        <br />
                      </>
                    )}
                    {employerDetails.empcontactfaxnumber && (
                      <>
                        {employerDetails.empcontactfaxnumber.replaceAll(
                          ",",
                          ", "
                        )}{" "}
                        <br />
                      </>
                    )}
                  </>
                ) : (
                  <span className="text-danger">No Record Found</span>
                )}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default EmployerDetailsCard;
